import StoredLayout from '../../layouts/StoredLayout'
import Credits from './Credits'
export default StoredLayout(Credits)
